<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Update Expected In-Out Time</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2" md="2" v-if="this.employee_type_list!=''">
            <p><v-icon color="error">*</v-icon><b>Employee Type</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type" @change="getEmployees()"
              :items="employee_type_list" item-text="name" item-value="id" label="Employee Type" outlined
              persistent-hint hint="Please Select Employee Type" />
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="this.employee_section_list!=''">
            <p><v-icon color="error">*</v-icon><b>Employee Section</b></p>
            <v-autocomplete color="#0F2027" dense rounded required @change="getEmployees()" v-model="employee_section"
              :items="employee_section_list" item-text="name" item-value="id" label="Employee Section" outlined
              persistent-hint hint="Please Select Employee Section" />
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="this.employee_shift_list!=''">
            <p><v-icon color="error">*</v-icon><b>Employee Shift</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="shift" @change="getEmployees()"
              :items="employee_shift_list" item-text="name" item-value="id" label="Employee Shift" outlined
              persistent-hint hint="Please Select Employee Shift" />
          </v-col>
          <v-col cols="12" sm="3" v-if="this.employee_list!=''">
            <p><v-icon color="error">*</v-icon><b>Employee</b></p>
            <v-autocomplete color="#0F2027" dense rounded required multiple v-model="employee" :items="employee_list"
              item-text="name" item-value="id" label="Employee" outlined persistent-hint
              hint="Please Select Employee" />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
            <v-radio label="Update Expected In Out" value="Updateexpinout" color="#0f2027"></v-radio>
            <v-radio label="Add / Remove Weekly Off" value="updatewo" color="#0f2027"></v-radio>
          </v-radio-group>
        </v-row>
        <v-row justify="center" dense v-if="this.employee_list!='' && this.radios=='Updateexpinout'">
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>From Date</b></p>
            <v-text-field outlined dense type="date" v-model="fromdate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>To Date</b></p>
            <v-text-field outlined dense type="date" v-model="todate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <p><b>Expected In-Time</b></p>
            <v-text-field outlined dense type="time" v-model="intime"></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <p><b>Expected Out-Time</b></p>
            <v-text-field outlined dense type="time" v-model="outtime"></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" dense v-if="this.employee_list!='' && this.radios=='updatewo'">
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Date</b></p>
            <v-text-field outlined dense type="date" v-model="fromdate"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="fromdate && todate && intime && outtime && this.radios=='Updateexpinout'">
          <v-btn color="primary" @click="getAttendanceData()">Update</v-btn>
        </v-row>
        <v-row justify="center" dense v-if="fromdate && this.radios=='updatewo'">
          <v-btn color="primary" @click="markWeeklyOff()">Update</v-btn>
        </v-row>




        <!-- <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Employee</b></p>
            <v-autocomplete color="#0F2027" dense rounded required multiple v-model="employee" :items="employee_list" item-text="name" item-value="id" label="Employee" outlined persistent-hint hint="Please Select Employee"/>
          </v-col>-->


      </v-card>

      <!-- <v-card class="box" v-if="query_list.length > 0">
     <v-data-table  :headers="headers" :items="query_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Queries</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
     </v-data-table>
 </v-card> -->
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      loader:false,
      radios: null,
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      fromdate: new Date().toISOString().slice(0, 10),
      todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
      headers:[
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      ],
      employee_list:[],employee:[], intime: "",employee_type_list:[],employee_section_list:[],employee_shift_list:[],employee_type:"",employee_section:"",shift:"",
    outtime: "",
  }),
   methods: {
    async markWeeklyOff(){
        if (!confirm("Are You Sure You Want To Update Expected In Out Time For These Employees...?")) return;
        const data = {
            fromdate:this.fromdate,
            employee:this.employee,
            employee_type: this.employee_type,
            section: this.employee_section,
            shift: this.shift,
        }
      try {
          const res = await axios.post("/EmployeeBiometric/savebulkUpdateWeeklyOff", data);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Updated Successfully..."); // show snackbar
             this.onLoad();
          } if (res.data.flag == "No") {
             this.showSnackbar("red", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
    },
      getEmployees() {
              this.employee_list = []
              //this.employee = null
                const data = {
                    employee_type: this.employee_type,
                    section: this.employee_section,
                    shift: this.shift,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/getEmployees", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_list = res.data.instructor_list;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
   async  onLoad(){
      try {
          const res = await axios.post("/EmployeeBiometric/bulkUpdateExpectedInout");
          if (res.data.flag == "YES") {
                this.employee_list=res.data.employee_list
                this.employee_type_list = res.data.employee_type_list;
                this.employee_section_list = res.data.employee_section_list;
                this.employee_shift_list = res.data.employee_shift_list;
                this.employee_type = this.employee_type_list[0].id;
                this.employee_section = this.employee_section_list[0].id;
                this.shift = this.employee_shift_list[0].id;
                //this.employee = this.employee_list[0].id;
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        //this.save_loader = false;
      }
    },
    async getAttendanceData() {
         if (!confirm("Are You Sure You Want To Update Expected In Out Time For These Employees...?")) return;
        const data = {
            fromdate:this.fromdate,
            todate:this.todate,
            employee:this.employee,
            intime:this.intime,
            outtime:this.outtime,
            employee_type: this.employee_type,
            section: this.employee_section,
            shift: this.shift,
        }
      try {
          const res = await axios.post("/EmployeeBiometric/savebulkUpdateExpectedInout", data);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Updated Successfully..."); // show snackbar
             this.onLoad();
          } if (res.data.flag == "No") {
             this.showSnackbar("red", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>